 <template>
  <v-menu v-bind="attrs.componentAttrs">
    <slot name="default">
      <v-list class="rounded-lg py-0" :data-locator="attrs.dataLocator" elevation="2" v-if="menu.length !== 0">
        <template v-for="(item, index) in menu" :key="`item${index}`">
          <v-divider v-if="item.title === 'separator'"/>
          <!-- Disabled items with an explanation are wrapped in a tooltip; other items keep the plain list-item DOM -->
          <AppTooltip v-else-if="item.disabled && item.disabledTooltip">
            <template #activator="{ props: tooltipProps }">
              <!-- We use a wrapper div to retain the disable styling _and_ the tooltip hover event -->
              <div v-bind="tooltipProps">
                <AppMenuItem :item="item" :icon-after="iconAfter" @item-click="doItemAction" />
              </div>
            </template>
            <span>{{ item.disabledTooltip }}</span>
          </AppTooltip>
          <AppMenuItem v-else :item="item" :icon-after="iconAfter" @item-click="doItemAction" />
        </template>
        <slot name="append"></slot>
      </v-list>
    </slot>
    <template v-slot:activator="attrs">
      <slot name="activator" v-bind="attrs"></slot>
    </template>
  </v-menu>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import AppMenuItem from '@/common/AppMenuItem.vue'
import AppTooltip from '@/common/AppTooltip.vue'
import { useDataLocator } from '@/common/utils/useDataLocator'
import type { MenuItemType } from '@/types/menu.d.ts'

export default defineComponent({
  name: 'AppMenu',
  inheritAttrs: false,
  setup() {
    const { attrs } = useDataLocator()
    return { attrs }
  },
  components: { AppMenuItem, AppTooltip },
  props: {
    menu: {
      type: Array as PropType<MenuItemType[]>,
      default: () => [],
    },
    iconAfter: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    doItemAction(item: MenuItemType): void {
      item.action(item)
    },
  },
})
</script>
